module.exports = {
          srcSet: "/_next/static/images/img-telephonie@2x-200-636f8a58b2c4fae06907a7025f786be3.jpg"+" 200w",
          images:[ {path: "/_next/static/images/img-telephonie@2x-200-636f8a58b2c4fae06907a7025f786be3.jpg",width: 200,height: 171}],
          src: "/_next/static/images/img-telephonie@2x-200-636f8a58b2c4fae06907a7025f786be3.jpg",
          toString:function(){return "/_next/static/images/img-telephonie@2x-200-636f8a58b2c4fae06907a7025f786be3.jpg"},
          placeholder: undefined,
          width: 200,
          height: 171
      }